module.exports = {"id":"1","name":"Kushyar Kasrae","initials":"KK","status":false}


//////////////////
// WEBPACK FOOTER
// ./src/actions/global/data.json
// module id = 1263
// module chunks = 0